// https://vuex.vuejs.org/en/actions.html

export default {
   resetState ({ commit }) {
     //console.log('clearing state')
      
      for (var property in this._actions) {
        if (property.indexOf('resetState') > -1) {
          commit(property)
        }
      }
      //document.location.reload()
    },
    message: ({ commit }, message) => commit('message', message),
    emit ({ commit }, {type, options}) {
      this.$socket.emit(type, options)
    },
    request ({ commit, dispatch }, {type, options, next}) {
      var self = this
      options.callback = type// + callId++
      self.$bus.sockets.subscribe(options.callback, (response) => {
        self.$bus.$emit(type, response)
        self.$bus.sockets.unsubscribe(options.callback);
        if (options.list) options.list = response.data
        if (next) next(response)
      });
      dispatch('emit', {type, options})
    },
   graph ({ commit, dispatch }, {type, options, next, end}) {
      var self = this
    // console.log('graph')
      if (!options.callback) options.callback = type + '.' + options.query // + callId++
      self.$bus.sockets.subscribe(options.callback, (response) => {
        console.log(response)
        var item = response[0]
        var count = response[1]
        if (Array.isArray(item)) {
          self.$bus.sockets.unsubscribe(options.callback);
        } else if (!item) {
          self.$bus.sockets.unsubscribe(options.callback);
          if (end) end()
          return false
        }
        
        self.$bus.$emit(type, item)
        if (options.list) options.list.push(item)
        if (next) next(item,count)
      });
      console.log(type,options)
      dispatch('emit', {type, options})
    }
}
